// Import bow PNG URLs

// Import avatar PNG URLs
import avatar1 from '../../assets/images/post-wrap/avatar-1.png';
import avatar2 from '../../assets/images/post-wrap/avatar-2.png';
import avatar3 from '../../assets/images/post-wrap/avatar-3.png';
import avatar4 from '../../assets/images/post-wrap/avatar-4.png';
import bowGreenHorizontal from '../../assets/images/post-wrap/bow-green-horizontal.png';
import bowGreenVertical from '../../assets/images/post-wrap/bow-green-vertical.png';
import bowLightPurpleHorizontal from '../../assets/images/post-wrap/bow-light-purple-horizontal.png';
import bowLightPurpleVertical from '../../assets/images/post-wrap/bow-light-purple-vertical.png';
import bowLightTealHorizontal from '../../assets/images/post-wrap/bow-light-teal-horizontal.png';
import bowLightTealVertical from '../../assets/images/post-wrap/bow-light-teal-vertical.png';
import bowPurpleHorizontal from '../../assets/images/post-wrap/bow-purple-horizontal.png';
import bowPurpleVertical from '../../assets/images/post-wrap/bow-purple-vertical.png';
import bowTealHorizontal from '../../assets/images/post-wrap/bow-teal-horizontal.png';
import bowTealVertical from '../../assets/images/post-wrap/bow-teal-vertical.png';
// Import custom PNG URLs
import custom1 from '../../assets/images/post-wrap/custom-1.png';
import custom2 from '../../assets/images/post-wrap/custom-2.png';
import custom3 from '../../assets/images/post-wrap/custom-3.png';
// Import all PNG URLs
import dotsGreen1 from '../../assets/images/post-wrap/dots-green-1.png';
import dotsGreen2 from '../../assets/images/post-wrap/dots-green-2.png';
import dotsGreen3 from '../../assets/images/post-wrap/dots-green-3.png';
// Import tile PNG URLs
import dotsGreenTile from '../../assets/images/post-wrap/dots-green-tile.png';
import dotsOrange1 from '../../assets/images/post-wrap/dots-orange-1.png';
import dotsOrange2 from '../../assets/images/post-wrap/dots-orange-2.png';
import dotsOrange3 from '../../assets/images/post-wrap/dots-orange-3.png';
import dotsOrangeTile from '../../assets/images/post-wrap/dots-orange-tile.png';
import dotsPink1 from '../../assets/images/post-wrap/dots-pink-1.png';
import dotsPink2 from '../../assets/images/post-wrap/dots-pink-2.png';
import dotsPink3 from '../../assets/images/post-wrap/dots-pink-3.png';
import dotsPinkTile from '../../assets/images/post-wrap/dots-pink-tile.png';
import dotsPurple1 from '../../assets/images/post-wrap/dots-purple-1.png';
import dotsPurple2 from '../../assets/images/post-wrap/dots-purple-2.png';
import dotsPurple3 from '../../assets/images/post-wrap/dots-purple-3.png';
import dotsPurpleTile from '../../assets/images/post-wrap/dots-purple-tile.png';
import dotsTeal1 from '../../assets/images/post-wrap/dots-teal-1.png';
import dotsTeal2 from '../../assets/images/post-wrap/dots-teal-2.png';
import dotsTeal3 from '../../assets/images/post-wrap/dots-teal-3.png';
import dotsTealTile from '../../assets/images/post-wrap/dots-teal-tile.png';
// Import EAD PNG URLs
import eadGreen1 from '../../assets/images/post-wrap/ead-green-1.png';
import eadGreen2 from '../../assets/images/post-wrap/ead-green-2.png';
import eadGreen3 from '../../assets/images/post-wrap/ead-green-3.png';
import eadOrange1 from '../../assets/images/post-wrap/ead-orange-1.png';
import eadOrange2 from '../../assets/images/post-wrap/ead-orange-2.png';
import eadOrange3 from '../../assets/images/post-wrap/ead-orange-3.png';
import eadPink1 from '../../assets/images/post-wrap/ead-pink-1.png';
import eadPink2 from '../../assets/images/post-wrap/ead-pink-2.png';
import eadPink3 from '../../assets/images/post-wrap/ead-pink-3.png';
import eadPurple1 from '../../assets/images/post-wrap/ead-purple-1.png';
import eadPurple2 from '../../assets/images/post-wrap/ead-purple-2.png';
import eadPurple3 from '../../assets/images/post-wrap/ead-purple-3.png';
import eadTeal1 from '../../assets/images/post-wrap/ead-teal-1.png';
import eadTeal2 from '../../assets/images/post-wrap/ead-teal-2.png';
import eadTeal3 from '../../assets/images/post-wrap/ead-teal-3.png';
import eadTile from '../../assets/images/post-wrap/ead-tile.png';
import plaidDark1 from '../../assets/images/post-wrap/plaid-dark-1.png';
import plaidDark2 from '../../assets/images/post-wrap/plaid-dark-2.png';
import plaidDark3 from '../../assets/images/post-wrap/plaid-dark-3.png';
import plaidLight1 from '../../assets/images/post-wrap/plaid-light-1.png';
import plaidLight2 from '../../assets/images/post-wrap/plaid-light-2.png';
import plaidLight3 from '../../assets/images/post-wrap/plaid-light-3.png';
import plaidTile from '../../assets/images/post-wrap/plaid-tile.png';
import rippleGreen1 from '../../assets/images/post-wrap/ripple-green-1.png';
import rippleGreen2 from '../../assets/images/post-wrap/ripple-green-2.png';
import rippleGreen3 from '../../assets/images/post-wrap/ripple-green-3.png';
import rippleOrange1 from '../../assets/images/post-wrap/ripple-orange-1.png';
import rippleOrange2 from '../../assets/images/post-wrap/ripple-orange-2.png';
import rippleOrange3 from '../../assets/images/post-wrap/ripple-orange-3.png';
import ripplePink1 from '../../assets/images/post-wrap/ripple-pink-1.png';
import ripplePink2 from '../../assets/images/post-wrap/ripple-pink-2.png';
import ripplePink3 from '../../assets/images/post-wrap/ripple-pink-3.png';
import ripplePurple1 from '../../assets/images/post-wrap/ripple-purple-1.png';
import ripplePurple2 from '../../assets/images/post-wrap/ripple-purple-2.png';
import ripplePurple3 from '../../assets/images/post-wrap/ripple-purple-3.png';
import rippleTeal1 from '../../assets/images/post-wrap/ripple-teal-1.png';
import rippleTeal2 from '../../assets/images/post-wrap/ripple-teal-2.png';
import rippleTeal3 from '../../assets/images/post-wrap/ripple-teal-3.png';
import rippleTile from '../../assets/images/post-wrap/ripple-tile.png';
import stripesGreen1 from '../../assets/images/post-wrap/stripes-green-1.png';
import stripesGreen2 from '../../assets/images/post-wrap/stripes-green-2.png';
import stripesGreen3 from '../../assets/images/post-wrap/stripes-green-3.png';
import stripesGreenTile from '../../assets/images/post-wrap/stripes-green-tile.png';
import stripesOrange1 from '../../assets/images/post-wrap/stripes-orange-1.png';
import stripesOrange2 from '../../assets/images/post-wrap/stripes-orange-2.png';
import stripesOrange3 from '../../assets/images/post-wrap/stripes-orange-3.png';
import stripesOrangeTile from '../../assets/images/post-wrap/stripes-orange-tile.png';
import stripesPink1 from '../../assets/images/post-wrap/stripes-pink-1.png';
import stripesPink2 from '../../assets/images/post-wrap/stripes-pink-2.png';
import stripesPink3 from '../../assets/images/post-wrap/stripes-pink-3.png';
import stripesPinkTile from '../../assets/images/post-wrap/stripes-pink-tile.png';
import stripesPurple1 from '../../assets/images/post-wrap/stripes-purple-1.png';
import stripesPurple2 from '../../assets/images/post-wrap/stripes-purple-2.png';
import stripesPurple3 from '../../assets/images/post-wrap/stripes-purple-3.png';
import stripesPurpleTile from '../../assets/images/post-wrap/stripes-purple-tile.png';
import stripesTeal1 from '../../assets/images/post-wrap/stripes-teal-1.png';
import stripesTeal2 from '../../assets/images/post-wrap/stripes-teal-2.png';
import stripesTeal3 from '../../assets/images/post-wrap/stripes-teal-3.png';
import stripesTealTile from '../../assets/images/post-wrap/stripes-teal-tile.png';

// Map pattern-color-state to imported URLs
const IMAGE_MAP: Record<string, string> = {
	'avatar-1': avatar1,
	'avatar-2': avatar2,
	'avatar-3': avatar3,
	'avatar-4': avatar4,
	'custom-1': custom1,
	'custom-2': custom2,
	'custom-3': custom3,
	'ead-green-1': eadGreen1,
	'ead-green-2': eadGreen2,
	'ead-green-3': eadGreen3,
	'ead-orange-1': eadOrange1,
	'ead-orange-2': eadOrange2,
	'ead-orange-3': eadOrange3,
	'ead-pink-1': eadPink1,
	'ead-pink-2': eadPink2,
	'ead-pink-3': eadPink3,
	'ead-purple-1': eadPurple1,
	'ead-purple-2': eadPurple2,
	'ead-purple-3': eadPurple3,
	'ead-teal-1': eadTeal1,
	'ead-teal-2': eadTeal2,
	'ead-teal-3': eadTeal3,
	'dots-green-1': dotsGreen1,
	'dots-green-2': dotsGreen2,
	'dots-green-3': dotsGreen3,
	'dots-orange-1': dotsOrange1,
	'dots-orange-2': dotsOrange2,
	'dots-orange-3': dotsOrange3,
	'dots-pink-1': dotsPink1,
	'dots-pink-2': dotsPink2,
	'dots-pink-3': dotsPink3,
	'dots-purple-1': dotsPurple1,
	'dots-purple-2': dotsPurple2,
	'dots-purple-3': dotsPurple3,
	'dots-teal-1': dotsTeal1,
	'dots-teal-2': dotsTeal2,
	'dots-teal-3': dotsTeal3,
	'plaid-dark-1': plaidDark1,
	'plaid-dark-2': plaidDark2,
	'plaid-dark-3': plaidDark3,
	'plaid-light-1': plaidLight1,
	'plaid-light-2': plaidLight2,
	'plaid-light-3': plaidLight3,
	'ripple-green-1': rippleGreen1,
	'ripple-green-2': rippleGreen2,
	'ripple-green-3': rippleGreen3,
	'ripple-orange-1': rippleOrange1,
	'ripple-orange-2': rippleOrange2,
	'ripple-orange-3': rippleOrange3,
	'ripple-pink-1': ripplePink1,
	'ripple-pink-2': ripplePink2,
	'ripple-pink-3': ripplePink3,
	'ripple-purple-1': ripplePurple1,
	'ripple-purple-2': ripplePurple2,
	'ripple-purple-3': ripplePurple3,
	'ripple-teal-1': rippleTeal1,
	'ripple-teal-2': rippleTeal2,
	'ripple-teal-3': rippleTeal3,
	'stripes-green-1': stripesGreen1,
	'stripes-green-2': stripesGreen2,
	'stripes-green-3': stripesGreen3,
	'stripes-orange-1': stripesOrange1,
	'stripes-orange-2': stripesOrange2,
	'stripes-orange-3': stripesOrange3,
	'stripes-pink-1': stripesPink1,
	'stripes-pink-2': stripesPink2,
	'stripes-pink-3': stripesPink3,
	'stripes-purple-1': stripesPurple1,
	'stripes-purple-2': stripesPurple2,
	'stripes-purple-3': stripesPurple3,
	'stripes-teal-1': stripesTeal1,
	'stripes-teal-2': stripesTeal2,
	'stripes-teal-3': stripesTeal3,
};

export function getCollectibleImageUrl(pattern: string, color: string, state = 1): string | undefined {
	return IMAGE_MAP[`${pattern}-${color}-${state}`] ?? IMAGE_MAP[`${pattern}-${state}`];
}

// Maps background color → bow color
const BG_TO_BOW_COLOR: Record<string, string> = {
	green: 'light-purple',
	purple: 'light-teal',
	orange: 'green',
	teal: 'purple',
	pink: 'teal',
	light: 'purple',
	dark: 'teal',
};

const TILE_MAP: Record<string, string> = {
	'ead-green': eadTile,
	'ead-orange': eadTile,
	'ead-pink': eadTile,
	'ead-purple': eadTile,
	'ead-teal': eadTile,
	'dots-green': dotsGreenTile,
	'dots-orange': dotsOrangeTile,
	'dots-pink': dotsPinkTile,
	'dots-purple': dotsPurpleTile,
	'dots-teal': dotsTealTile,
	'stripes-green': stripesGreenTile,
	'stripes-orange': stripesOrangeTile,
	'stripes-pink': stripesPinkTile,
	'stripes-purple': stripesPurpleTile,
	'stripes-teal': stripesTealTile,
	'plaid-light': plaidTile,
	'plaid-dark': plaidTile,
	'ripple-green': rippleTile,
	'ripple-orange': rippleTile,
	'ripple-pink': rippleTile,
	'ripple-purple': rippleTile,
	'ripple-teal': rippleTile,
};

export function getTileImageUrl(pattern: string, color: string): string | undefined {
	return TILE_MAP[`${pattern}-${color}`];
}

const BOW_HORIZONTAL_MAP: Record<string, string> = {
	green: bowGreenHorizontal,
	'light-purple': bowLightPurpleHorizontal,
	'light-teal': bowLightTealHorizontal,
	purple: bowPurpleHorizontal,
	teal: bowTealHorizontal,
};

const BOW_VERTICAL_MAP: Record<string, string> = {
	green: bowGreenVertical,
	'light-purple': bowLightPurpleVertical,
	'light-teal': bowLightTealVertical,
	purple: bowPurpleVertical,
	teal: bowTealVertical,
};

export function getBowHorizontalImageUrl(bgColor: string): string | undefined {
	const bowColor = BG_TO_BOW_COLOR[bgColor];
	return bowColor ? BOW_HORIZONTAL_MAP[bowColor] : undefined;
}

export function getBowVerticalImageUrl(bgColor: string): string | undefined {
	const bowColor = BG_TO_BOW_COLOR[bgColor];
	return bowColor ? BOW_VERTICAL_MAP[bowColor] : undefined;
}

export function getGreenBowHorizontalImageUrl(): string {
	return bowGreenHorizontal;
}

export function getGreenBowVerticalImageUrl(): string {
	return bowGreenVertical;
}

export const GIFT_WRAP_BG_COLORS: Record<string, string> = {
	green: 'green.300',
	pink: 'pink.300',
	teal: 'teal.300',
	orange: 'orange.300',
	purple: 'purple.300',
	light: 'white',
	dark: 'gray.900',
};

export function getGiftWrapBgColor(color: string): string {
	return GIFT_WRAP_BG_COLORS[color] ?? 'white';
}

// Base hex colors for EAD (employee appreciation day) backgrounds.
// Uses color.300 tokens as the ThemePattern seed.
const EAD_HEX_COLORS: Record<string, string> = {
	green: '#4BB475',
	purple: '#9C8EF1',
	orange: '#FF8B1B',
	teal: '#44C0B5',
	pink: '#FA82AF',
};

export function getEadHexColor(color: string): string | undefined {
	return EAD_HEX_COLORS[color];
}
